import { tsv } from "@faire/slate/lib/tsv";
import React, { InputHTMLAttributes } from "react";

type IProps = Omit<
  InputHTMLAttributes<HTMLInputElement>,
  "aria-checked" | "type"
> & {
  hasLabel: boolean;
  ref?: React.Ref<HTMLInputElement>;
};

export const RadioBase: React.FC<IProps> = ({
  checked,
  hasLabel,
  className,
  ...props
}) => {
  const inputCls = inputStyle.cls({ className, hasLabel });
  return (
    <input
      {...props}
      aria-checked={checked}
      checked={checked}
      className={inputCls}
      type="radio"
    />
  );
};

const inputStyle = tsv({
  base: ["fs-radio__input focusable interactive"],
  variants: {
    hasLabel: {
      true: "type-aligned-elem",
    },
  },
});
